export const LOADER_STATUS = 'boilderplate/Gstr1New/UploadPage/LOADER_STATUS';
export const FILE_DATA = 'boilderplate/Gstr1New/UploadPage/FILE_DATA';
export const SAVE_TOTAL_PAGES = 'boilderplate/Gstr1New/UploadPage/SAVE_TOTAL_PAGES';
export const SET_TABLE_DATA = 'gstr1New/SET_TABLE_DATA';
export const SET_MULTIPLE_GSTIN_DATA = 'gstr1New/SET_MULTIPLE_GSTIN_DATA';
